import React from 'react';
import i18n from 'react-intl-universal';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

export default ({ ...props }) => {
  return (
    <ListItem
      button
      onMouseEnter={event =>
        !props.open && props.handleItemHover(event, i18n.get(props.i18nTitle))
      }
      onMouseLeave={() => !props.open && props.setPopperHoverOpen(false)}
      key={props.key}
      onClick={() => props.handleItemClick()}
      selected={props.open && props.expand ? true : false}
      className={props.open ? '' : props.classes.justifyCenter}
    >
      <ListItemIcon className={props.classes.zeroMargin}>
        <props.Icon />
      </ListItemIcon>
      {props.open && (
        <React.Fragment>
          <ListItemText
            primary={
              <Typography noWrap={true}>{i18n.get(props.i18nTitle)}</Typography>
            }
          />
          {props.showExpandIcon && (
            <ListItemIcon>
              {props.expand ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItemIcon>
          )}
        </React.Fragment>
      )}
    </ListItem>
  );
};
